import React, { useImperativeHandle, useState } from "react";
import { Modal, Form } from "@components";
import { useTranslation } from "react-i18next";
import { useToast } from "@hooks";

export const TableModal = React.forwardRef((props: any, ref) => {
  const { form, initial, onUpdate, onAdd, schema, loading } = props;
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState<string>("add");
  const [index, setIndex] = useState<any>(null);

  const toast = useToast();

  useImperativeHandle(ref, () => ({
    handleOpen(data: any, index?: number) {
      if (data) {
        form.reset(data);
        setModalTitle("update");
        setIndex(index);
      } else {
        form.reset(initial);
        setModalTitle("add");
      }
      setOpen(true);
    },
  }));

  const onSubmit = async (values: any) => {
    try {
      if (modalTitle === "update") {
        await onUpdate(values.id, values, index);
      } else {
        await onAdd(values);
      }
      form.reset(initial);
      setOpen(false);

      toast.success(
        values?.id ? t("update_success_message") : t("create_success_message")
      );
    } catch (err) {
      const error = err as any;

      if (error.status === 406) {
        const messages = error.data.Messages;

        messages.forEach((msg: { Key: string; Value: string }) => {
          if (msg.Key) {
            form.setError(msg.Key, msg.Value);
          } else {
            toast.error(msg.Value);
          }
        });
      }
    }
  };

  return (
    <Modal
      onClose={() => {
        form.reset(initial);
      }}
      title={t(modalTitle)}
      open={open}
      setOpen={setOpen}
      loading={loading}
      onConfirm={form.handleSubmit(onSubmit)}
    >
      <Form schema={schema} form={form} />
    </Modal>
  );
});
